import * as React from "react";

import { ContactFilters } from "components/contacts/contactUtils";
import PaywallPopover from "components/paywall/PaywallPopover";
import Button from "components/ui/button/Button";
import { useCheckSubscription } from "lib/providers/ProHelper";
import { TrackingProvider } from "lib/tracking";
import RequestContactsModal from "./RequestContactsModal";

import css from "./RequestContactsButton.module.scss";

type RequestContactsButtonProps = {
  contextSource: string;
  contactFilters?: ContactFilters;
  title?: string;
  notice?: {
    guid: string;
    name: string;
    buyer?: { guid: string; name: string };
  };
};

function RequestContactsButton({
  contactFilters,
  title,
  contextSource,
  notice,
}: RequestContactsButtonProps): JSX.Element {
  const [requestContactsModalIsOpen, setRequestContactsModalIsOpen] = React.useState(false);

  if (!notice?.guid && !contactFilters) {
    throw new Error(
      "Either 'notice' or 'contactFilters' must be provided to RequestContactsButton.",
    );
  }

  const { authorised: hasContacts } = useCheckSubscription("CONTACTS", {
    "Context source": contextSource,
  });

  return (
    <TrackingProvider
      data={{
        "Context source": contextSource,
      }}
    >
      {requestContactsModalIsOpen && (
        <RequestContactsModal
          isOpen={requestContactsModalIsOpen}
          onClose={() => setRequestContactsModalIsOpen(false)}
          contactFilters={contactFilters}
          notice={notice}
        />
      )}
      <PaywallPopover featureType="CONTACTS" contextSource={contextSource}>
        <Button
          className={css.requestContactButton}
          onClick={(e) => {
            e.stopPropagation();
            if (hasContacts) {
              setRequestContactsModalIsOpen(true);
            }
          }}
        >
          {title ?? "Request Contacts"}
        </Button>
      </PaywallPopover>
    </TrackingProvider>
  );
}

export default RequestContactsButton;
